import Vue from 'vue'
import HTTP from '@/http-common.js'

const state = {
  list: [],
  item: {},
  searchParams: {
    types: [],
    search_query: '',
    offset: 0,
    limit: 24,
    order_by: 'updated',
    order_dir: 'desc',
    org_id: null,
  },
  loading: false,
}

const mutations = {
  setUploads(state, { items, body }) {
    state.list = items
    state.searchParams = body
  },
  getSingleUpload(state, item) {
    state.item = item
  },
  setUploadItem(state, item) {
    const newItem = JSON.parse(JSON.stringify(item)) // Prevent changing store directly
    const index = state.list.findIndex((x) => x.id === newItem.id)
    Vue.set(state.list, index, newItem)
  },
  addNewUploadItem(state, item) {
    if (state.list.media) {
      state.list.media.unshift(item)
      state.list.count += 1
    }
  },
  removeUploadItem(state, id) {
    const index = state.list.findIndex((x) => x.id === id)
    state.list.splice(index, 1)
  },
  setUploadsLoading(state, val) {
    state.loading = val
  },
}

const actions = {
  getUploads({ commit, state }, params) {
    commit('setUploadsLoading', true)
    return new Promise((resolve, reject) => {
      const body = { ...state.searchParams, ...params }

      HTTP.post('search/media', body).then(
        (response) => {
          resolve(commit('setUploads', { items: response.data, body }))
          commit('setUploadsLoading', false)
        },
        (error) => {
          reject(error)
          commit('setUploadsLoading', false)
        }
      )
    })
  },
  addNewUploadItem({ commit }, item) {
    commit('addNewUploadItem', item)
  },
  setUploadsLoading({ commit }, val) {
    commit('setUploadsLoading', val)
  },
}

export default {
  state,
  actions,
  mutations,
}
